var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWixLogo = function SvgWixLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 64,
    viewBox: "0 0 166 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#wixLogo_svg__a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.304 0h-9.131a7.639 7.639 0 0 0-6.323 3.352l-12.211 18.014a.82.82 0 0 1-1.356 0L124.071 3.352A7.635 7.635 0 0 0 117.748 0h-9.131l21.754 32.09L108.737 64h9.131a7.64 7.64 0 0 0 6.324-3.352l12.091-17.835a.82.82 0 0 1 1.356 0l12.091 17.835A7.634 7.634 0 0 0 156.053 64h9.131l-21.633-31.91L165.304 0ZM89.828 6.547V64h4.364a6.546 6.546 0 0 0 6.548-6.547V0h-4.364a6.546 6.546 0 0 0-6.548 6.547ZM81.828 0h-3.884a9.154 9.154 0 0 0-8.928 7.126l-8.688 38.193-7.605-35.653C51.317 3.077 44.556-1.366 37.638.544c-4.407 1.217-7.674 4.94-8.627 9.41L21.484 45.27 12.812 7.128A9.162 9.162 0 0 0 3.88 0H0l14.555 63.997h5.514c5.005 0 9.329-3.498 10.373-8.393l9.304-43.664c.115-.542.6-.934 1.153-.934s1.038.392 1.153.934l9.313 43.667a10.603 10.603 0 0 0 10.372 8.39h5.533L81.828 0Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "wixLogo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h165.305v64H0z"
  })))));
};
export default SvgWixLogo;